// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.1.0",
  date: "2026-06-17T10:52:04.758Z",
  gitInfo: {
    dirty: false,
    raw: "1eae4fea9",
    hash: "1eae4fea9",
    distance: null,
    tag: null,
    semver: null,
    suffix: "1eae4fea9",
    semverString: null
  }
};
/* tslint:enable */
